import { css } from '@emotion/react'
import { getPeriodFilterText } from 'components/filteritem/utils-filterItem'
import { FilterTag, FilterTags } from 'components/filtertags'
import { LotacoesComRegulacoesSelectFieldModel } from 'components/form/field/select/LotacoesComRegulacoesSelectField/LotacoesComRegulacoesSelectField'
import { StatusRegulacaoEnum, TipoRegulacaoEnum } from 'graphql/types.generated'
import { useServerTime } from 'hooks/useServerTime'
import { emptyArrayOf } from 'util/array'
import { isUndefinedOrNull } from 'util/checks'
import { stringGrouper } from 'util/string/string-grouper'

import { ListaRegulacaoTableFilterModel, RegulacaoEnumTextMap } from '../model-regulacao'

export interface ListaRegulacaoFilterTagsProps {
  filtros: ListaRegulacaoTableFilterModel
}

export function ListaRegulacaoFilterTags(props: Readonly<ListaRegulacaoFilterTagsProps>) {
  const { filtros } = props
  const { getServerTimeNow } = useServerTime()
  const now = getServerTimeNow()

  const isPeriodoFilled = !isUndefinedOrNull(filtros.periodo?.startDate) || !isUndefinedOrNull(filtros.periodo?.endDate)

  const filterTags: FilterTag[] = [
    ['Período', isPeriodoFilled && getPeriodFilterText(filtros.periodo, now), styles.periodoColumn],
    [
      'Solicitantes',
      stringGrouper(
        ...(filtros.solicitantes ?? emptyArrayOf<LotacoesComRegulacoesSelectFieldModel>()).map(
          (item) => item?.profissional?.nome
        )
      ),
    ],
    [
      'Status',
      stringGrouper(
        ...(filtros.statusRegulacao ?? emptyArrayOf<StatusRegulacaoEnum>())
          .map((status) => RegulacaoEnumTextMap[status])
          .reverse()
      ),
    ],
    [
      'Tipo de solicitação',
      stringGrouper(
        ...(filtros.tipoRegulacao ?? emptyArrayOf<TipoRegulacaoEnum>())
          .map((tipo) => RegulacaoEnumTextMap[tipo])
          .reverse()
      ),
    ],
  ]

  return <FilterTags tags={filterTags} />
}

const styles = {
  periodoColumn: css`
    overflow: visible;
  `,
}
